import { callApi } from "../callApi"

export const deleteFleetsUuidFenceId = async (
  partnerUuid: string,
  fleetUuid: string,
  fenceId: number,
) =>
  callApi<null, null>({
    method: "DELETE",
    path: `/partner/${partnerUuid}/fleets/${fleetUuid}/fences/${fenceId}`,
  })
